// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__cZ_7i","content":"GlobalSearch_content__36BmX"};